import { useCallback, useRef } from "react";
import { useUnmount } from "react-use";

export const useHoldTimer = (delayMs: number) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearHoldTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startHoldTimer = useCallback(
    (onHoldElapsed: () => void) => {
      clearHoldTimer();
      timerRef.current = setTimeout(onHoldElapsed, delayMs);
    },
    [clearHoldTimer, delayMs]
  );

  useUnmount(clearHoldTimer);

  return { startHoldTimer, clearHoldTimer };
};
